import { useMemo } from "react";
import RoyaltiesPresenter from "./RoyaltiesPresenter";
import { ConnectionName } from "@arelia-types/connection";
import { useAllRequiredConnections } from "@arelia-utils/helpers/useRequiredConnections";
import { useRecordingRoyaltiesSummaryQuery } from "../../api/earnings";
import { ComponentProps } from "@arelia-types/widget";
import { RevenueOverview } from "../../types/earnings";

export default function RecordingRoyaltiesWidgetContainer({ config }: ComponentProps) {
  const requiredConnectionNames = [ConnectionName.distrokid, ConnectionName.cdBaby];
  const requiredConnections = useAllRequiredConnections(requiredConnectionNames);

  const { data, isLoading, isError } = useRecordingRoyaltiesSummaryQuery({
    enabled: requiredConnections.length > 0
  });

  const royalties: RevenueOverview = useMemo(() => {
    const lastUpdatedAt = requiredConnections.map(x => new Date(x.updatedAt)).sort()[0];
    return {
      updatedAt: (lastUpdatedAt ?? new Date()).toISOString(),
      total: data?.total ?? 0,
      topLevelTotal: 0,
      totalThisPeriod: data?.currentMonth ?? 0,
      totalPrevPeriod: data?.previousMonth ?? 0,
      totalRecordCount: 0,
      data: []
    };
  }, [requiredConnections, data]);

  return (
    <RoyaltiesPresenter
      data={royalties}
      loading={isLoading}
      error={isError}
      detailsPagePath={config.detailsPagePath}
      widgetId="RECORDING_ROYALTIES"
      title="Streaming Royalties"
      unconnected={requiredConnections.length === 0}
    />
  );
}
